<template>
  <VisibleByVerizonDrawer
    v-if="
      productResponse &&
      visiblePartnerPromoCode &&
      hasPartnerPromoCode(
        productResponse.includedServiceOffers.partnerPromoCodes,
        'VISIBLE',
      )
    "
    :promo-code="visiblePartnerPromoCode"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import VisibleByVerizonDrawer from '~/scopes/product/components/CustomizationFunnel/components/VisibleByVerizonDrawer/VisibleByVerizonDrawer.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { hasPartnerPromoCode } from '~/scopes/product-core/utils/hasPartnerPromoCode/hasPartnerPromoCode'

const { data: productResponse } = useFetchProduct()

const visiblePartnerPromoCode = computed(() => {
  return productResponse.value?.includedServiceOffers.partnerPromoCodes.find(
    (partnerPromoCode) => partnerPromoCode.partnerName === 'VISIBLE',
  )
})
</script>
